export const isOutfitProduct = (product) => {
    var _a, _b;
    const typeValue = product.productType || ((_b = (_a = product.customAttributes) === null || _a === void 0 ? void 0 : _a.product_type) === null || _b === void 0 ? void 0 : _b[0]);
    if (!typeValue)
        return false;
    return String(typeValue).toLowerCase().includes('outfit');
};
export const isVideoProduct = (product) => {
    var _a, _b;
    const typeValue = product.productType || ((_b = (_a = product.customAttributes) === null || _a === void 0 ? void 0 : _a.product_type) === null || _b === void 0 ? void 0 : _b[0]);
    if (!typeValue)
        return false;
    return String(typeValue).toLowerCase().includes('video');
};
/**
 * Strip a Shopify GID down to its numeric id (`gid://shopify/Product/123` → `123`).
 * Pass-through for ids that are already short.
 */
export const shortShopifyId = (id) => id.startsWith('gid://') ? id.split('/').pop() : id;
const PLACEHOLDER_COLOR_CODE_MAP = {
    blue: { plp_filter_image: null, plp_hex: '#1e40af' },
    naturals: { plp_filter_image: null, plp_hex: '#d4a574' },
    white: { plp_filter_image: null, plp_hex: '#ffffff' },
    multi: { plp_filter_image: null, plp_hex: 'linear-gradient(135deg, #ff6b6b 25%, #4ecdc4 25%, #4ecdc4 50%, #ffe66d 50%, #ffe66d 75%, #95e1d3 75%)' },
    black: { plp_filter_image: null, plp_hex: '#1a1a1a' },
    pink: { plp_filter_image: null, plp_hex: '#ec4899' },
    red: { plp_filter_image: null, plp_hex: '#ef4444' },
    purple: { plp_filter_image: null, plp_hex: '#a855f7' },
    green: { plp_filter_image: null, plp_hex: '#22c55e' },
    yellow: { plp_filter_image: null, plp_hex: '#eab308' },
    orange: { plp_filter_image: null, plp_hex: '#f97316' },
    brown: { plp_filter_image: null, plp_hex: '#92400e' },
    grey: { plp_filter_image: null, plp_hex: '#6b7280' },
    gray: { plp_filter_image: null, plp_hex: '#6b7280' },
    beige: { plp_filter_image: null, plp_hex: '#d4b896' },
    navy: { plp_filter_image: null, plp_hex: '#1e3a5f' },
    cream: { plp_filter_image: null, plp_hex: '#fffdd0' },
};
// Static map: read once from <script id="colour-group-swatch-map"> and store at module scope (raw parse, no conversion).
let colorCodeMap = null;
function getResolvedColorMap() {
    var _a;
    if (colorCodeMap)
        return colorCodeMap;
    const el = typeof document !== 'undefined' ? document.getElementById('colour-group-swatch-map') : null;
    if (!((_a = el === null || el === void 0 ? void 0 : el.textContent) === null || _a === void 0 ? void 0 : _a.trim())) {
        colorCodeMap = PLACEHOLDER_COLOR_CODE_MAP;
        return colorCodeMap;
    }
    try {
        colorCodeMap = JSON.parse(el.textContent.trim());
    }
    catch (e) {
        console.error('[colour-group-swatch-map] Failed to parse JSON:', e);
        colorCodeMap = PLACEHOLDER_COLOR_CODE_MAP;
    }
    return colorCodeMap;
}
/** Returns plp_filter_image (use this) and plp_hex (use when plp_filter_image is null) from the metaobject map. */
export function getColorFromMetaobjectMap(colorLabel) {
    return getResolvedColorMap()[colorLabel.toLowerCase()];
}
// Birdsnest TV tabs are encoded as the SECOND segment of the URL path
// (e.g. /collections/birdsnest-tv/live-replay). Tab id = the slug; the original
// Fredhopper facet value (e.g. "Live Replay") is recovered by un-handlising.
//
// ⚠️ SHOPIFY ROUTING: A 2-segment collection URL like /collections/birdsnest-tv/live-replay
// is NOT served by Shopify out of the box — direct loads / reloads will 404 unless the
// theme is explicitly configured (e.g. a catch-all template or rewrite) to serve the same
// page for the sub-path. Confirm with the theme team before shipping. Click-navigation
// works regardless because we use pushState in-page; only direct URL hits are at risk.
export const handlize = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
// ⚠️ NAIVE: replaces `-` with space and title-cases each word. Works for the current
// Birdsnest TV facet values (Title Case English: "Live Replay", "One Style Three Ways").
// Will break for values with apostrophes ("O'Brien"), accents, lowercase brand names
// ("iPad"), or already-hyphenated terms ("mid-century"). If those ever appear, swap
// for a lookup map keyed on `handle → original option.id` built from cachedTvTabsRef.
export const unhandlize = (s) => s.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
export const readTvTabSlugFromPath = () => {
    if (typeof window === 'undefined')
        return 'all';
    const m = window.location.pathname.match(/^\/collections\/[^/]+\/([^/]+)\/?$/);
    return m ? m[1] : 'all';
};
export const buildTvPath = (slug) => {
    const path = typeof window !== 'undefined' ? window.location.pathname : '/';
    const m = path.match(/^(\/collections\/[^/]+)/);
    // ⚠️ DEV FALLBACK: when the path doesn't match `/collections/<handle>` (e.g. local
    // dev where pathname is `/`), strip any trailing segment instead so repeated tab
    // clicks don't keep nesting (`/live-replay/as-seen-on/...`). The resulting URL
    // looks like `/live-replay`, which is fine for dev but not a real Shopify route.
    // The `/collections/<handle>` branch is the production path.
    const base = m ? m[1] : (path.replace(/\/[^/]+\/?$/, '') || '/');
    return slug === 'all' ? base : `${base.replace(/\/$/, '')}/${slug}`;
};
